import { Navigate, Route, Routes } from 'react-router-dom';

import { Login } from './Login';
import { Session } from './Session';
import { TwoFA } from './TwoFA';

export const AuthRoutes = () => {
  return (
    <Routes>
      <Route path="login" element={<Login />} />
      <Route path="login/2fa" element={<TwoFA />} />
      <Route path="session/timeout" element={<Session />} />
    </Routes>
  );
};
